import {GbpConfiguration} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/gbpconfiguration';
import {GbpSyncedFields} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/gbp/gbpsyncedfields';
import {EnterpriseConfiguration} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/enterpriseconfiguration';
import {Task} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/task';
import {TaskIds} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/taskids';

import BookSvg from '/src/com/yext/listingslaunchstorm/public/icons/book.svg';
import GoogleBusinessProfileLogoLargeSvg from '/src/com/yext/listingslaunchstorm/public/icons/google-business-profile-logo-large.svg';
import GoogleBusinessProfileLogoSvg from '/src/com/yext/listingslaunchstorm/public/icons/google-business-profile-logo.svg';

export const GbpSyncedFieldsTask = new Task({
  id: TaskIds.GBP_SYNCED_FIELDS,

  getCard: (_enterpriseConfiguration, _index, selectedPageId, setSelectedPageId, disabled) => ({
    id: TaskIds.GBP_SYNCED_FIELDS,
    title: yext.msg('Field Sync & Mapping'),
    icon: <GoogleBusinessProfileLogoSvg />,
    isSelected: TaskIds.GBP_SYNCED_FIELDS === selectedPageId,
    onClick: disabled ? undefined : () => setSelectedPageId(TaskIds.GBP_SYNCED_FIELDS),
    content: undefined,
  }),

  getPage: (enterpriseConfiguration, setEnterpriseConfiguration, _pageControls) => ({
    id: TaskIds.GBP_SYNCED_FIELDS,
    layoutHeader: {
      icon: <GoogleBusinessProfileLogoLargeSvg />,
      title: yext.msg('Google Business Profile'),
      description: yext.msg('Configure the sync settings below to prevent the syncing of certain fields or to change the default mapped field. If no changes are made, all default settings will be applied.'),
      resourceLink: {
        src: 'https://hitchhikers.yext.com/tracks/listings/lis310-google-my-business/',
        external: true,
        displayText: yext.msg('Learn About the Google Business Profile Integration'),
        icon: <BookSvg />,
      },
    },
    content: <GbpSyncedFields
      gbpConfiguration={enterpriseConfiguration.gbpConfiguration ?? GbpConfiguration.empty()}
      setGbpConfiguration={gbpConfiguration => setEnterpriseConfiguration(
        new EnterpriseConfiguration({...enterpriseConfiguration, gbpConfiguration}),
      )}
    />,
  }),

  isComplete: () => true,
  isSectionSkipped: () => false,
});
